import React, { useState, useEffect, useContext } from 'react';
import { Form, Button, Row, Col } from 'react-bootstrap';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import '../../assets/css/EditProfile.css'; // Optional for extra styling
import axios from 'axios';
import ENDPOINT from '../../data/ENDPOINT'; // Adjust path as needed
import { AuthContext } from '../../context/AuthContext'; // Adjust path as needed
import { Snackbar, CircularProgress } from '@material-ui/core'; // For snackbar and loader
import settingsimg from '../../assets/images/image copy.png'; // Use the image from second code
import { Link } from 'react-router-dom'; // For privacy link

// Assuming Cities is an array of strings from context, but to match first code's Typeahead with state, we'll mock or adjust
// If Cities is strings, convert to objects { label: city }
import Cities from '../../context/Cities'; // Adjust path; assuming it's ['City1', 'City2', ...]

// Convert to objects if needed (for Typeahead with filterBy ['label'])
const cityOptions = Cities.map(city => ({ label: city }));

const EditUserInfo = () => {
  const { user } = useContext(AuthContext);

  const [account, setAccount] = useState(null);
  const [fname, setFname] = useState('');
  const [lname, setLname] = useState('');
  const [city, setCity] = useState(null); // Will be string or object; adjust for Typeahead
  const [address, setAddress] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [gender, setGender] = useState('');
  const [whatsapp, setWhatsapp] = useState(''); // Included as in second code, but input commented; add if needed

  const [status, setStatus] = useState(false); // For loading
  const [snackbar, setSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState(null);

  useEffect(() => {
    const getAccount = async () => {
      if (!user) return;

      const data = new FormData();
      data.append('session', user.SessionId);

      try {
        const res = await axios.post(ENDPOINT + 'get-user-info.php', data, {
          headers: { 'content-type': 'multipart/form-data' },
        });

        if (res.data && res.data[0].status === 'success') {
          const result = res.data[0].data;
          setAccount(result);
          setFname(result.first_name || '');
          setLname(result.last_name || '');
          setCity(result.city || null);
          setAddress(result.address || '');
          setEmail(result.email || '');
          setPhone(result.phone_number || '');
          setWhatsapp(result.whatsapp_number || '');
          setGender(result.gender || ''); // Assuming gender is in response; add if present
        }
      } catch (error) {
        console.error('Error fetching account:', error);
      }
    };

    if (user) {
      getAccount();
    }
  }, [user]);

  const saveProfile = async (e) => {
    e.preventDefault();
    setStatus(true);

    const formData = new FormData();
    formData.append('session', user.SessionId);
    formData.append('first_name', fname);
    formData.append('last_name', lname);

    // Safe city handling (no optional chaining)
    let cityValue = '';
    if (city) {
      if (typeof city === 'object' && city.label) {
        cityValue = city.label;
      } else if (typeof city === 'string') {
        cityValue = city;
      }
    }
    formData.append('city', cityValue);

    formData.append('address', address);
    formData.append('whatsapp', whatsapp);
    formData.append('gender', gender);

    try {
      const res = await axios.post(ENDPOINT + 'edit-profile.php', formData, {
        headers: { 'content-type': 'multipart/form-data' },
      });

      if (res.data && res.data[0].status === 'success') {
        setSnackbarMessage('Profile updated successfully');
        setSnackbar(true);
      } else {
        setSnackbarMessage('Failed to update profile');
        setSnackbar(true);
      }
    } catch (error) {
      console.error('Error saving profile:', error);
      setSnackbarMessage('Error updating profile');
      setSnackbar(true);
    } finally {
      setStatus(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    // SetPage('Edit Profile'); // Uncomment if SetPage is available
  }, []);

  return (
    <div className="container py-5 mt-5">
      <div className="row">
        {/* Left: Form */}
        <div className="col-lg-6 mb-4">
          <div className="p-4 border rounded shadow-sm bg-white">
            <form onSubmit={saveProfile}>
              <Row className="mb-3">
                <Col>
                  <Form.Label>First Name *</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="First Name"
                    value={fname}
                    onChange={(e) => setFname(e.target.value)}
                    required
                  />
                </Col>
                <Col>
                  <Form.Label>Last Name *</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Last Name"
                    value={lname}
                    onChange={(e) => setLname(e.target.value)}
                    required
                  />
                </Col>
              </Row>

              <Form.Group className="mb-3">
                <Form.Label>Primary Email</Form.Label>
                <Form.Control type="email" value={email} readOnly disabled />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Primary Phone</Form.Label>
                <Form.Control type="text" value={phone} readOnly disabled />
              </Form.Group>

              <Row className="mb-3">
                <Col>
                  <Form.Label>Gender</Form.Label>
                  <Form.Select
                    value={gender}
                    onChange={(e) => setGender(e.target.value)}
                  >
                    <option>Gender</option>
                    <option>Male</option>
                    <option>Female</option>
                    <option>Others</option>
                  </Form.Select>
                </Col>
                <Col>
                  <Form.Label>City</Form.Label>
                  <Typeahead
                    id="city-selector"
                    options={cityOptions}
                    labelKey="label"
                    placeholder="Choose a city..."
                    filterBy={['label']}
                    selected={city ? [cityOptions.find(opt => opt.label === city) || { label: city }] : []}
                    onChange={(selected) => setCity(selected[0] || null)}
                    renderMenuItemChildren={(option) => (
                      <div>
                        <strong>{option.label}</strong>
                      </div>
                    )}
                  />
                </Col>
              </Row>

              <Form.Group className="mb-3">
                <Form.Label>Address</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Enter your address"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                />
              </Form.Group>

              <Button style={{ background: "linear-gradient(90deg, #f68139, #ff9960)",}}  type="submit" className="w-100 border border-0" disabled={status}>
                {status ? <CircularProgress size={20} className="text-white" /> : 'Save Changes'}
              </Button>
            </form>
          </div>
        </div>

        {/* Right: Illustration */}
  <div className="col-lg-6 d-flex flex-column justify-content-center align-items-center text-center px-5">
          <img
            src={settingsimg}
            alt="Privacy Illustration"
            className="img-fluid mb-3"
            style={{ maxHeight: '280px' }}
          />
          <p className="text-muted">
            If you'd like to learn more about privacy, you can read about it in the{' '}
            <a href="/privacy-policy" className="link-primary">Privacy Policy</a>.
          </p>
        </div>
      </div>

      <Snackbar
        open={snackbar}
        autoHideDuration={6000}
        onClose={() => setSnackbar(false)}
        message={snackbarMessage}
      />
    </div>
  );
};

export default EditUserInfo;